// Dependencies
import { graphql, useStaticQuery } from 'gatsby';

const useBlogPostDefaultCtaOptions = () => {
  const { options } = useStaticQuery(graphql`
    query BlogPostDefaultCtaOptions {
      options: wp {
        global {
          blog {
            bannerHeading: defaultBannerCtaHeading
            bannerText: defaultBannerCtaText
            bannerButtons: defaultBannerCtaButtons {
              button {
                target
                title
                url
              }
            }
            bannerBackgroundImage: defaultBannerCtaBackgroundImage {
              altText
              gatsbyImage(width: 1920, placeholder: NONE)
              localFile {
                publicURL
              }
              mediaDisplayOptions {
                filter
              }
            }
          }
        }
      }
    }
  `);

  return options?.global?.blog;
};

export default useBlogPostDefaultCtaOptions;
